module.exports = __webpack_public_path__ + "img/309x417.d815edd6.png";